import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { useSessionPermissions } from "./behavior/use-session-permissions.ts";
import { AUTH_CATALOGS } from "./model/auth-copy.ts";
import { AUTH_ERROR_COPY } from "./model/auth-error-copy.ts";

// S12.01: auth owns the session, so it supplies the session's permissions the router and the
// shell gate staff-only screens and entries on (`withPermissionsSource`, @amtana/browser).
export const authBrowserModule: BrowserModule = defineBrowserModule("auth")
  .withPermissionsSource(useSessionPermissions)
  .withErrorCopy(AUTH_ERROR_COPY)
  .withScreens({
    login: {
      path: "/login",
      title: phrase(AUTH_CATALOGS, "screenTitleLogin"),
      layout: "auth",
      load: () => import("./ui/sections/login-screen.tsx"),
    },
    register: {
      path: "/register",
      title: phrase(AUTH_CATALOGS, "screenTitleRegister"),
      layout: "auth",
      load: () => import("./ui/sections/register-screen.tsx"),
    },
    forgot: {
      path: "/forgot-password",
      title: phrase(AUTH_CATALOGS, "screenTitleForgot"),
      layout: "auth",
      load: () => import("./ui/sections/forgot-password-screen.tsx"),
    },
    verify: {
      path: "/verify",
      title: phrase(AUTH_CATALOGS, "screenTitleVerify"),
      layout: "auth",
      load: () => import("./ui/sections/verify-screen.tsx"),
    },
    // Google's /auth/google/callback and LinkedIn's /auth/linkedin/callback (ADR-007).
    signInCallback: {
      path: "/auth/:provider/callback",
      title: phrase(AUTH_CATALOGS, "screenTitleCallback"),
      layout: "auth",
      load: () => import("./ui/sections/sign-in-callback-screen.tsx"),
    },
    action: {
      path: "/auth/action",
      title: phrase(AUTH_CATALOGS, "screenTitleAction"),
      layout: "auth",
      load: () => import("./ui/sections/auth-action-screen.tsx"),
    },
  });
